import React, { Fragment, useEffect, useState } from 'react'
import { Button, Col, DatePicker, Form, Row, Select, Spin, Tag, message } from 'antd';
import dayjs from 'dayjs';
import {
  SearchOutlined,
} from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../store/loading/actions';
import { adminService } from '../../services/admin.service';
import { DividerStyled, TabContentStyled, TableStyled } from '../../components/CustomAntStyled';
import { currencyFormat, formatDateTime, formatNumber } from '../../helpers/FunctionUtils';
import { ColumnsType } from 'antd/es/table';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';

export const AdminForControlSmsPartnerTab = () => {
  const dispatch = useDispatch();
  const [lstPartner, setLstPartner] = useState<any[]>([]);
  const [dataObj, setDataObj] = useState<any>(null);
  const [formSearch] = Form.useForm();

  useEffect(() => {
    const initData = async () => {
      dispatch(setLoading(true));
      try {
        formSearch.setFieldsValue({
          tuNgay: dayjs(),
          denNgay: dayjs(),
        });
        onSearch();

        const resPartner = await adminService.filterPartner(0, 9999, null, null, 0)
        if (resPartner.status === 200) {
          setLstPartner(resPartner.data.data);
        } else {
          message.error({ content: resPartner.message, duration: 3 });
        }
      }
      catch (error: any) {
        message.error({ content: error.message as string, duration: 2 });
      } finally {
        dispatch(setLoading(false));
      }
    };
    initData();
  }, []);

  const onSearch = async () => {
    dispatch(setLoading(true));
    try {
      const values = await formSearch.validateFields();
      const dayCheck = dayjs(values.denNgay).diff(dayjs(values.tuNgay), 'day');
      if (dayCheck > 90) {
        message.error("Khoản thời gian tìm kiếm không được quá 90 ngày");
        return;
      }
      const response = await adminService.adminForSmsControl(
        values.tuNgay.format('DD/MM/YYYY 00:00:00'), values.denNgay.format('DD/MM/YYYY 00:00:00'),
        values.partnerId, null, values.productType
      )
      if (response.code === 0) {
        setDataObj(response.data);
      } else {
        message.error({ content: response.message, duration: 3 });
      }
    } catch (error) {
      message.error({ content: 'Tham số không hợp lệ, hãy kiểm tra lại', duration: 2 });
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <TabContentStyled>
      <Form
        form={formSearch}
        layout='vertical'>
        <Row gutter={[20, 0]}>
          <Col xs={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <Form.Item
              name="tuNgay" // Tên của trường trong form
              label='Từ ngày'
              rules={[
                {
                  required: true,
                  message: 'Vui lòng chọn ngày đăng',
                }
              ]}
            >
              <DatePicker
                format="DD/MM/YYYY"
                showTime={false}
                inputReadOnly={true}
                size='large'
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>
            <Form.Item
              name="denNgay" // Tên của trường trong form
              label='Đến ngày'
              rules={[
                {
                  required: true,
                  message: 'Vui lòng chọn ngày đăng',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    const tuNgayValue = getFieldValue('tuNgay');
                    if (value && value.isBefore(tuNgayValue, 'day')) {
                      return Promise.reject('Phải lớn hơn thời gian bắt đầu');
                    } else {
                      return Promise.resolve();
                    }
                  },
                }),
              ]}>
              <DatePicker
                format="DD/MM/YYYY"
                showTime={false}
                inputReadOnly={true}
                size='large'
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item
              name="partnerId"
              label="Đối tác">
              <Select defaultValue={''} size="large" showSearch optionFilterProp="label">
                <option value="" label=''>-- All --</option>
                {lstPartner?.map((item: any, index) => (
                  <Select.Option key={index} value={item.id} label={item.user.firstName}>{item.user.firstName}</Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item name="productType" label="Nhà mạng">
              <Select size='large' defaultValue={'ALL'} style={{ width: '100%' }}
                placeholder="Nhà mạng">
                <Select.Option key={'ALL'} value='ALL'>
                  -- All --
                </Select.Option>
                <Select.Option key={'viettel'} value='viettel'>
                  VIETTEL
                </Select.Option>
                <Select.Option key={'vinaphone'} value='vinaphone'>
                  VINAPHONE
                </Select.Option>
                <Select.Option key={'mobifone'} value='mobifone'>
                  MOBIFONE
                </Select.Option>
                <Select.Option key={'vietnamobile'} value='vietnamobile'>
                  VIETNAMOBILE
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <Row justify="end" style={{ marginBottom: '10px' }}>
        {/* <ButtonPlatedGreenStyled onClick={onExportExcel} style={{ marginRight: '10px' }} type="primary" icon={<FaDownload />}>
          Xuất excel
        </ButtonPlatedGreenStyled> */}
        <Button onClick={onSearch} type="primary" icon={<SearchOutlined />}>
          Xem đối soát
        </Button>
      </Row>

      <Row gutter={20}>
        <DividerStyled orientation="left" orientationMargin="0" dashed style={{ fontSize: '18px' }}>
          Tổng quan số liệu
        </DividerStyled>
        <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
          <TableStyled>

            <tr style={{ fontWeight: '600', color: 'rgb(0 155 45)' }}>
              <td>Số giao dịch thành công</td>
              <td>
                {dataObj ? formatNumber(dataObj?.tongThanhCong) : <Spin />} <br />
              </td>
              <td>
                {
                  dataObj ?
                    (
                      dataObj?.tongGiaoDich > 0 ?
                        formatNumber((dataObj?.tongThanhCong / dataObj?.tongGiaoDich) * 100) + ' %'
                        : 0
                    )
                    : <Spin />
                }
              </td>
            </tr>

            <tr style={{ fontWeight: '600', color: 'rgb(243 0 0)' }}>
              <td>Số giao dịch thất bại</td>
              <td>
                {dataObj ? formatNumber(dataObj?.tongThatBai) : <Spin />}
              </td>
              <td>
                {
                  dataObj ?
                    (
                      dataObj?.tongGiaoDich > 0 ?
                        formatNumber((dataObj?.tongThatBai / dataObj?.tongGiaoDich) * 100) + ' %'
                        : 0
                    )
                    : <Spin />
                }
              </td>
            </tr>

            <tr style={{ fontWeight: '600' }}>
              <td>Tổng số giao dịch</td>
              <td>
                {dataObj ? formatNumber(dataObj?.tongGiaoDich) : <Spin />}
              </td>
              <td>
                {
                  dataObj ?
                    (
                      dataObj?.tongGiaoDich > 0 ?
                        '100 %' : '0 %'
                    )
                    : <Spin />
                }
              </td>
            </tr>
            {/* <tr>
              <th>Trung bình thời gian thành công</th>
              <th colSpan={2}>{dataObj ? formatNumber(dataObj?.thoiGianThanhCongTrungBinh) + ' s' : <Spin />}</th>
            </tr> */}
          </TableStyled>
        </Col>

        <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }} xl={{ span: 12 }}>
          <TableStyled>
            <tr>
              <th>Nhà mạng</th>
              <th>Số lượng</th>
            </tr>
            {dataObj?.countTheoMenhGia && (
              Object.keys(dataObj?.countTheoMenhGia).map((menhGiaKey: any, index: any) => {
                const innerMap = dataObj?.countTheoMenhGia[menhGiaKey];
                Object.keys(dataObj?.countTheoMenhGia).map((menhGiaKey: any, index: any) => {
                  const innerMap = dataObj?.countTheoMenhGia[menhGiaKey];
                  return (
                    <tr key={index * 100 + menhGiaKey}>
                      <td>{menhGiaKey}</td>
                      <td>{innerMap}</td>
                    </tr>
                  );
                })
              })
            )}
            <tr>
              <th>Tổng tiền đối tác trả</th>
              <th colSpan={2}>{dataObj ? currencyFormat(dataObj?.tongTienDoiTacMuaHang, 'VND') : <Spin />}</th>
            </tr>
            <tr>
              <th>Lợi nhuận</th>
              <th colSpan={2}>{dataObj ? currencyFormat(dataObj?.loiNhuan, 'VND') : <Spin />}</th>
            </tr>
          </TableStyled>
        </Col>
      </Row>
      {/* <Row gutter={20}>
        <DividerStyled orientation="left" orientationMargin="0" dashed style={{ fontSize: '18px' }}>
          Chi tiết giao dịch
        </DividerStyled>

        <TableContainer>
          <TableContentStyled
            columns={columns}
            dataSource={dataObj?.listTransAdminThanhCong}
            rowKey="id"
            bordered
          />
        </TableContainer>
      </Row> */}
    </TabContentStyled>
  )
}
